/* eslint-disable import/prefer-default-export */
export function setTitle(title: string): void {
  if (title) {
    document.title = `${title} - Gyre`;
  } else {
    document.title = "Gyre";
  }
}
